import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/forgotpassword.css';
import axios from 'axios';
import { UserContext } from '../UserContext';

const ForgotPassword = () => {
    const [step, setStep] = useState('email_input');
    const [email, setEmail] = useState('');
    const [OTP, setOtp] = useState('');
    const [NewPassword, setNewPassword] = useState('');
    const [ConfirmNewPassword, setConfirmNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [Id, setUserId] = useState();
    const navigate = useNavigate();
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

    const { logout } = useContext(UserContext);
    const API_URL = process.env.REACT_APP_Login_API_URL;

    useEffect(() => {
        const hash = window.location.hash; // "#/forgotpassword?logout=true"
        const queryString = hash.split('?')[1];

        if (queryString) {
            const params = new URLSearchParams(queryString);
            const Id = params.get("userId");
            setUserId(Id);
            if (Id) {
                setStep('reset_password');
                logout();
            } else {
                setError("Invalid User.")
            }
        }
    }, [logout]);

    const validatePassword = (password) => {
        const errors = [];
        if (password.length < 8) {
            errors.push('Password should be at least 8 characters long');
        }
        if (!/[A-Z]/.test(password)) {
            errors.push('Password should include at least 1 uppercase letter');
        }
        if (!/[a-z]/.test(password)) {
            errors.push('Password should include at least 1 lowercase letter');
        }
        if (!/[0-9]/.test(password)) {
            errors.push('Password should include at least 1 number');
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
            errors.push('Password should include at least 1 special character');
        }
        setPasswordError(errors.length > 0 ? errors[0] : '');
        return errors.length === 0;
    };

    const handleEmailSubmit = async (e) => {
        e?.preventDefault();
        try {
            const response = await axios.post(API_URL + "forgot-password", {
                email
            });
            if (response.status === 200) {
                setMessage('OTP sent to your email.');
                setStep('otp_verification');
            } else {
                setMessage('');
                setError('');
            }
        } catch (error) {
            setError(error.response?.data?.error);
            setTimeout(() => {
                setError('');
            }, 5000);
        }
    };

    const handleOtpVerification = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');
        try {
            const response = await axios.post(`${API_URL}verify-otp`, {
                email,
                OTP
            });
            if (response.status === 200) {
                setUserId(response.data.id);
                setMessage('OTP verified. Please set your new password');
                setStep('reset_password');
            } else {
                setTimeout(() => {
                    setError(response.data.message || "Invalid OTP. Please try again.");
                }, 2000);
            }
        } catch (error) {
            setTimeout(() => {
                setError(error.response?.data?.error);
            }, 2000);
        }
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!validatePassword(NewPassword)) {
            return;
        } else if (NewPassword !== ConfirmNewPassword) {
            setError('New password and confirm password do not match.');
            return;
        }
        try {
            const response = await axios.post(API_URL + "reset-password", {
                Id,
                NewPassword
            });
            if (response.status === 200) {
                setMessage(response.data.message || 'Password successfully reset!');
                setTimeout(() => {
                    setMessage('');
                    navigate("/loginsignup") // Navigate to the login page
                }, 5000);
            } else {
                // Handle non-200 responses
            }
        } catch (error) {
            setError(error.response?.data?.Error);
        }
    };

    const handleResendOtp = () => {
        setMessage('');
        setError('');
        handleEmailSubmit();
        setMessage('Again OTP sent to your email.');
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-box">
                <button
                    className="back-to-login-button"
                    onClick={() => navigate('/loginsignup')}
                    aria-label="Back to Login"
                >
                    <i className="fas fa-arrow-left"></i>
                </button>

                <h2>Forgot Password</h2>

                {error && <div className="forgot-password-error">{error}</div>}
                {message && <div className="forgot-password-message">{message}</div>}

                {step === 'email_input' && (
                    <form onSubmit={handleEmailSubmit}>
                        <div className="input-wrapper-row">
                            <i className="fas fa-envelope icon-colored email-icon"></i>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="forgot-password-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>
                        <button type="submit" className="forgot-password-button">Send OTP</button>
                    </form>
                )}

                {step === 'otp_verification' && (
                    <form onSubmit={handleOtpVerification}>
                        <div className="input-wrapper-row">
                            <i className="fas fa-key icon-colored lock-icon"></i>
                            <input
                                type="text"
                                maxLength={6}
                                placeholder="Enter 6-digit OTP"
                                className="forgot-password-input"
                                value={OTP}
                                onChange={(e) => setOtp(e.target.value)}
                            />
                        </div>
                        <button type="submit" className="forgot-password-button">Verify OTP</button>
                        <p className="resend-otp-text" onClick={handleResendOtp}>Resend OTP</p>
                    </form>
                )}

                {step === 'reset_password' && (
                    <form onSubmit={handlePasswordReset}>
                        <div className="input-container">
                            <div className="input-wrapper-row">
                                <i className="fas fa-lock icon-colored lock-icon"></i>
                                <input
                                    type={showNewPassword ? 'text' : 'password'}
                                    placeholder="Create new password"
                                    className="forgot-password-input"
                                    value={NewPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <span
                                    className="password-toggle-icon"
                                    onClick={() => setShowNewPassword(!showNewPassword)}
                                >
                                    <i className={`fas ${showNewPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </span>
                            </div>
                        </div>
                        <div className="input-container">
                            <div className="input-wrapper-row">
                                <i className="fas fa-lock icon-colored lock-icon"></i>
                                <input
                                    type={showConfirmNewPassword ? 'text' : 'password'}
                                    placeholder="Confirm new password"
                                    className="forgot-password-input"
                                    value={ConfirmNewPassword}
                                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                                />
                                <span
                                    className="password-toggle-icon"
                                    onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                >
                                    <i className={`fas ${showConfirmNewPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                </span>
                            </div>
                        </div>
                        {passwordError && (
                            <div className="forgot-password-error-msg">{passwordError}</div>
                        )}
                        <button type="submit" className="forgot-password-button">Reset Password</button>
                    </form>
                )}

                <p className="forgot-password-toggle">
                    Remembered your password? <span onClick={() => navigate('/loginsignup')}>Login</span>
                </p>
            </div>
        </div>
    );
};

export default ForgotPassword;